const footerGroups = [
  {
    title: "内容",
    links: ["今日热度榜", "大图选读", "本周清单", "看料目录"],
  },
  {
    title: "关于",
    links: ["站点说明", "信息来源", "整理规则", "更新日志"],
  },
  {
    title: "入口",
    links: ["网页版首页", "移动端下载", "热度订阅", "意见反馈"],
  },
];

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-foreground-950 text-background-50">
                <i className="ri-newspaper-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">黑料看料</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-700">
              黑料看料首页汇总近期热门人物与事件的黑料盘点，按话题热度整理清单与目录。
              全站内容仅做公开信息归拢与目录化呈现，方便浏览与检索。
            </p>
          </div>

          {footerGroups.map((group) => (
            <div key={group.title} className="lg:col-span-2">
              <h4 className="font-heading text-sm font-bold text-foreground-950">{group.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {group.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#top"
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-700 cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-3">
            <h4 className="font-heading text-sm font-bold text-foreground-950">下载入口</h4>
            <p className="mt-4 text-sm text-foreground-600">扫码或直接下载，随时查看最新清单。</p>
            <a
              href="#entry"
              className="mt-4 inline-flex h-10 items-center gap-2 rounded-md bg-primary-500 px-5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-2-line text-base" />
              前往下载
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-600">
            © 2026 黑料看料 · 黑料看料盘点 / 黑料看料一览 / 黑料看料目录
          </p>
          <p className="text-xs text-foreground-500">
            内容仅为公开信息整理，本站不对任何个人作事实认定。
          </p>
        </div>
      </div>
    </footer>
  );
}